import qs from 'qs';

export function postData(url = "", data = {}) {
  const myData = qs.stringify(data);
  return fetch(url, {
    method: "POST",
    mode: "no-cors",
    // cache: "no-cache",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: myData
  }).then(response => response.json());
}
